import React from "react";
import PropTypes from "prop-types";
import * as colors from "@material-ui/core/colors";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import TButton from "../Buttons/TButton";
import TDialog from "../Dialogs/TDialog";
import TEdit from "../Edits/TEdit";
import TLabel from "../Labels/TLabel";

class GBLoginForm extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        onHandleLogin: PropTypes.func.isRequired,
        onLoginSuccess: PropTypes.func.isRequired,
        onHandleForgotPassword: PropTypes.func.isRequired,
        onHandleCreateAccount: PropTypes.func.isRequired,
        onPageChange: PropTypes.func,
        showCreateAccountBtn: PropTypes.bool,
        showForgotPasswordLabel: PropTypes.bool,
    };

    static defaultProps = {
        onHandleLogin: (username, value) => {
            console.log("onHandleLogin");
        },
        onLoginSuccess: () => {
            console.log("onLoginSuccess");
        },
        onHandleForgotPassword: () => {
            console.log("onHandleForgotPassword");
        },
        onHandleCreateAccount: () => {
            console.log("onHandleCreateAccount");
        },
        onPageChange: () => {
            console.log("onPageChange");
        },
        showCreateAccountBtn: true,
        showForgotPasswordLabel: true,
    };

    constructor(props) {
        super(props);

        this.state = {
            userNameValue: "",
            passwordValue: "",
            userNameErrorText: "",
            passwordErrorText: "",
            dialogVisible: false,
            dialogMessage: "",
        };
    }

    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    onUserNameChange = (value) => {
        this.setState({
            userNameValue: value,
        });
    };

    onPasswordChange = (value) => {
        this.setState({
            passwordValue: value,
        });
    };

    onHandleCloseDialog = () => {
        this.setState({
            dialogVisible: false,
            dialogMessage: "",
        });
    };

    onHandleLogin = () => {
        this.setState({
            userNameErrorText: this.state.userNameValue === "" ? "Username is required" : "",
            passwordErrorText: this.state.passwordValue === "" ? "Password is required" : "",
        });

        if (this.state.userNameValue !== "" && this.state.passwordValue !== "") {
            const mySuccess = (response) => {
                if (response === true) {
                    this.props.onLoginSuccess();
                    //this.props.onPageChange('back');
                } else {
                    this.setState({
                        dialogVisible: true,
                        dialogMessage: "Wrong username or password",
                    });
                }
            };

            const myError = (msg) => {
                this.setState({
                    dialogVisible: true,
                    dialogMessage: msg,
                });
            };

            this.props.onHandleLogin(
                {
                    username: this.state.userNameValue,
                    password: this.state.passwordValue,
                },
                mySuccess,
                myError
            );
        }
    };

    onHandleForgotPassword = () => {
        // <a style={styles.forgotPasswordStyle} target={"_blank"} onClick={this.onHandleForgotPassword}>Forgot my password</a>
        this.props.onHandleForgotPassword();
    };

    onHandleCreateAnAccount = () => {
        this.props.onHandleCreateAccount();
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    renderErrorDialog = () => {
        return (
            <TDialog
                caption="Error"
                visible={this.state.dialogVisible}
                message={this.state.dialogMessage}
                modal={true}
                actions={["mrOK"]}
            />
        );
    };

    renderPaperBox = () => {
        let styles = {
            paperBox: {
                width: 350,
                margin: "0 auto",
            },
            loginBox: {
                width: 300,
                margin: "0 auto",
            },
        };

        return (
            <Paper style={styles.paperBox}>
                <div style={styles.loginBox}>
                    {this.renderSignInLabel()}
                    {this.renderErrorPanel()}
                    {this.renderUsernameEdit()}
                    {this.renderPasswordEdit()}
                    {this.renderForgotPasswordLabel()}
                    {this.renderLoginBtn()}
                    <Divider />
                    {this.renderCreateAccountBtn()}
                </div>
            </Paper>
        );
    };

    renderSignInLabel = () => {
        let styles = {
            signIn: {
                paddingTop: 25,
                fontWeight: "normal",
            },
        };

        return <h1 style={styles.signIn}>Sign in</h1>;
    };

    renderErrorPanel = () => {
        let styles = {
            errorTitle: {
                margin: "0 0 10px 0",
                fontWeight: "bold",
            },
            errorParagraph: {
                margin: "0 0 10px 0",
            },
            errorBox: {
                background: "#EF9A9A",
                borderRadius: "5px",
                padding: "10px",
                marginBottom: "20px",
            },
        };

        if (this.state.dialogVisible) {
            return (
                <div style={styles.errorBox}>
                    <p style={styles.errorTitle}>Error</p>
                    <p style={styles.errorParagraph}>{this.state.dialogMessage}</p>
                </div>
            );
        } else {
            return null;
        }
    };

    renderUsernameEdit = () => {
        // let styles = {
        //     floatingLabelStyle: {
        //         color: colors.cyan[500],
        //         top : 15
        //     },
        //     textFieldStyle: {
        //         width: '100%'
        //     }
        // };

        return (
            <TEdit
                name="UsernameEdit"
                caption={"Username"}
                value={this.state.userNameValue}
                onChange={this.onUserNameChange}
                errorText={this.state.userNameErrorText}
                style={{ width: "100%" }}
            />
        );
    };

    renderPasswordEdit = () => {
        // let styles = {
        //     floatingLabelStyle: {
        //         color: colors.cyan[500],
        //         top : 15
        //     },
        //     textFieldStyle: {
        //         width: '100%'
        //     }
        // };

        return (
            <TEdit
                name="PasswordEdit"
                caption="Password"
                value={this.state.passwordValue}
                onChange={this.onPasswordChange}
                errorText={this.state.passwordErrorText}
                style={{ width: "100%" }}
                type="Password"
            />
        );
    };

    renderForgotPasswordLabel = () => {
        let styles = {
            forgotPasswordStyle: {
                fontSize: 12,
                textAlign: "right",
                paddingRight: 0,
                color: colors.grey[500],
                float: "right",
                marginTop: -10,
                marginBottom: 10,
                textTransform: "uppercase",
                // cursor: 'pointer'
            },
        };

        let forgotPasswordLabel = null;

        if (this.props.showForgotPasswordLabel) {
            forgotPasswordLabel = (
                <TLabel
                    caption="Forgot my password"
                    onClick={this.onHandleForgotPassword}
                    style={styles.forgotPasswordStyle}
                />
            );
        }

        return forgotPasswordLabel;
    };

    renderLoginBtn = () => {
        let styles = {
            raisedButton: {
                marginTop: 20,
                marginBottom: 30,
                marginRight: 20,
                width: "100%",
            },
        };

        return (
            <TButton
                caption={"Log in"}
                color={"primary"}
                onClick={this.onHandleLogin}
                style={styles.raisedButton}
                containerStyle={{ display: "block" }}
            />
        );
    };

    renderCreateAccountBtn = () => {
        let styles = {
            raisedButtonCreate: {
                marginTop: 30,
                marginBottom: 30,
                marginRight: 20,
                width: "100%",
            },
        };

        let createAccountBtn = null;

        if (this.props.showCreateAccountBtn) {
            createAccountBtn = (
                <TButton
                    caption={"Create an account"}
                    color={"secondary"}
                    onClick={this.onHandleCreateAnAccount}
                    style={styles.raisedButtonCreate}
                    containerStyle={{ display: "block" }}
                />
            );
        }

        return createAccountBtn;
    };

    render() {
        return (
            <div>
                {/*{this.renderErrorDialog()}*/}
                {this.renderPaperBox()}
            </div>
        );
    }
}

export default GBLoginForm;
